import Vue from 'vue'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.less'

// 全局注册高频基础组件(收敛跨页重复:提示条/弹窗底部/筛选栏/分页)
import TipBar from './components/base/TipBar.vue'
import DialogFooter from './components/base/DialogFooter.vue'
import FilterBar from './components/base/FilterBar.vue'
import Pager from './components/base/Pager.vue'
import DataTable from './components/base/DataTable.vue'

Vue.use(ViewUI)
Vue.component('TipBar', TipBar)
Vue.component('DialogFooter', DialogFooter)
Vue.component('FilterBar', FilterBar)
Vue.component('Pager', Pager)
Vue.component('DataTable', DataTable)
Vue.config.productionTip = false

// 游戏列表单一数据源:挂载前同步 seed,确保任何页面 created 读取时已有值
// (fetchGames 的动态 import 是异步的,首屏来不及;此处同步填充,接口刷新走 fetchGames)
store.commit('setGames', JSON.parse(JSON.stringify(require('@/config/games').GAMES)))

const app = new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

// 首屏 loading 收尾(对齐原站:挂载后移除 boot-loading)
const boot = document.getElementById('boot-loading')
if (boot) boot.remove()

export default app
